<template>
  <v-chip
    class="sn-chip"
    v-bind="vuetifyOverrideMixin.bindings"
    v-on="$listeners"
  >
    <!-- Pass on all named slots -->
    <slot
      v-for="slot in Object.keys($slots)"
      :slot="slot"
      :name="slot"
    />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
  </v-chip>
</template>

<script>
import vuetifyOverrideMixin from '~/components/snui/v2/mixins/vuetifyOverrideMixin.vue'

export default {
  name: 'SnChip',
  mixins: [vuetifyOverrideMixin],
  data () {
    return {
      vuetifyOverrideMixin: {
        defaultProps: {
        },
        // Supported props: disabled, color
        overriddenProps: {
          active: true,
          activeClass: '',
          close: false,
          closeIcon: '$delete',
          closeLabel: '$vuetify.close',
          dark: false,
          draggable: false,
          exact: false,
          exactActiveClass: undefined,
          exactPath: false,
          filter: false,
          filterIcon: '$complete',
          href: undefined,
          inputValue: undefined,
          label: false,
          large: false,
          light: false,
          link: false,
          nuxt: false,
          outlined: false,
          pill: false,
          replace: false,
          ripple: undefined,
          small: false,
          tag: 'span',
          target: undefined,
          textColor: undefined,
          to: undefined,
          value: undefined,
          xLarge: false,
          xSmall: false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/components/snui/v2/mixins/vuetifyOverrideCss.scss';

.sn-chip {
  @extend .v-chip--sn_override;
}

</style>
